import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideQueryService } from 'src/app/core/services/query.service';
import { IIstatComune } from './istat-comuni.model';
import { ISTATCOMUNI_ENDPOINT, istatComuniStateConfig } from './istat-comuni.config';
import { IstatComuniService } from './istat-comuni.service';
import { IstatComuniRoutingModule } from './istat-comuni-routing.module';

@NgModule({
  declarations: [],
  providers: [
    ...provideQueryService<IIstatComune>(ISTATCOMUNI_ENDPOINT, istatComuniStateConfig),
    IstatComuniService
  ],
  imports: [
    CommonModule,
    IstatComuniRoutingModule
  ]
})
export class IstatComuniModule { }
